import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px',
    listStyleType: 'none',
    borderRadius: 4,
    border: 'solid 1px rgb(147, 113, 255)',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 29, height: 29, marginRight: 10 },
  item: {
    position: 'relative',
    paddingLeft: 40,
    '&:nth-of-type(3)': {
      paddingLeft: 60,
    },
    '&:nth-of-type(4)': {
      paddingLeft: 82,
    },
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },

  wrap: {
    position: 'relative',
  },
  settingEdit: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}))
